<button climbButton size="md" variant="ghost" (click)="forceAutoSizeFacets()">
    <svg [climbIcon]="icons.topBar" size="sm"></svg>
</button>
